export default __webpack_public_path__ + "kishoralo-black.png";